module.exports = __webpack_public_path__ + "img/shape-drop-main.e3f1e09d.svg";